<template lang="pug">
  v-container#news(fluid)
    h1.form-title.dark-text Notas periodísticas
    v-layout.py-3(row wrap)
      v-container(xs-12 fluid)
        v-layout(column)
          v-form
            v-layout.px-3.py-2.light-background(row wrap justify-space-between)
              //v-flex.pr-2(xs12 sm6 md4)
                v-text-field(
                  v-model="mainMediaName"
                  ref="Medios de comunicación (nota principal)"
                  label="Medios de comunicación (nota principal)"
                )
              //v-flex.pr-2(xs12 sm6 md4)
                v-text-field(
                  v-model="mainMediaDate"
                  ref="Fecha de publicación"
                  label="Fecha de publicación"
                  )
                v-menu(
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  max-width="290px"
                  )
                  template(
                    slot="activator"
                  )
                    v-text-field(
                      :value="dateFormattedMomentjs(mainMediaDate)"
                      label="Fecha de publicación"
                      prepend-icon="event"
                      readonly
                    )
                  v-date-picker(v-model="mainMediaDate" @input="menu2 = false" color="grey lighten-2")
              //v-flex.pr-2(xs12 sm6 md4)              
                v-text-field(
                  v-model="mainMediaTitle"
                  ref="Titular"
                  label="Titular"
                )
              //v-flex.pr-2(xs12 sm6)
                v-select(
                  :items="options['yesNo']"
                  ref="¿La nota la acompaña una foto?"
                  v-model="mainMediaHasPicture"
                  label="¿La nota la acompaña una foto?"
                  placeholder="S/D"
                )
              //v-flex.pr-2(xs12 sm6)
                v-select(
                  :items="options['yesNo']"
                  ref="¿La foto vulnera la dignidad de la víctima?"
                  v-model="mainMediaIsPictureOffensive"
                  label="¿La foto vulnera la dignidad de la víctima?"
                  placeholder="S/D"
                )
              //v-flex.pr-2(xs12 sm6)
                v-select(
                  :items="options['yesNo']"
                  ref="En la nota, ¿la víctima aparece como responsable del crimen ya sea de manera explícita o implícita?"
                  v-model="mainMediaBlameVictim"
                  label="En la nota, ¿la víctima aparece como responsable del crimen ya sea de manera explícita o implícita?"
                  placeholder="S/D"
                )                
              //v-flex.pr-2(xs12 sm6)
                v-text-field(
                  v-model="mainMediaDetails"
                  ref="Especifica"
                  label="Especifica"
                )
              //v-flex.pr-2(xs12 sm6)
                v-text-field(
                  v-model="mainMediaSources"
                  ref="Fuentes consultadas"
                  label="Fuentes consultadas"
                )
              v-flex.pr-2(xs12 d-flex)
                v-text-field(
                  v-model="mainMediaLink"
                  ref="Liga a la nota principal"
                  label="Liga a la nota principal"
                )
                v-icon.visible(v-if="mainMediaLinkVisible" @click="visible('mainMediaLink')") visibility
                v-icon.visible(v-if="!mainMediaLinkVisible" @click="visible('mainMediaLink')") visibility_off
            v-layout.mt-5(
              row
              wrap
              align-center
              v-for="(news, index) in otherMedia"
            )
              v-flex.px-3.pt-4(xs1)
                v-checkbox(
                  :value="news.selected"
                  v-model="news.selected"                  
                  color="red darken-3"
                )
                //v-if="!(index === otherMedia.length - 1)"
              v-flex.px-3(xs sm)
                v-text-field(
                  label="Otras notas"
                  :value="news.mainLink"
                  v-model="news.mainLink"
                  required
                )
              v-flex.px-3(xs sm)
                v-text-field(
                  label="Nota de seguimiento"
                  :value="news.followupLink"
                  v-model="news.followupLink"
                )
            v-layout(row wrap justify-space-between)
              v-btn.add(
                small
                fab
                dark
                @click="addOtherMedia"
              )
                v-icon(dark) add
              v-flex(xs6 sm5 md4)
                v-btn.victim-btn(flat @click="saveOtherMedia") Guardar notas
                v-btn.victim-btn(flat, @click="deleteOtherMedia") Borrar selección
</template>
<script>
import moment from "moment";

export default {
  name: "News",
  props: {},
  data() {
    return {
      menu2: false,
    };
  },
  computed: {
    record() {
      return this.$store.getters.record;
    },
    options() {
      return this.$store.getters.options;
    },
    mainMediaLinkVisible: {
      get() {
        return this.$store.state.record.mainMediaLinkVisible;
      },
      set(value) {
        this.$store.commit("updateMainMediaLinkVisible", value);
      }
    },
    mainMediaName: {
      get() {
        return this.$store.state.record.mainMediaName;
      },
      set(value) {
        this.$store.commit("updateMainMediaName", value);
      }
    },
    mainMediaDate: {
      get() {
        return this.$store.state.record.mainMediaDate;
      },
      set(value) {
        this.$store.commit("updateMainMediaDate", value);
      }
    },
    mainMediaTitle: {
      get() {
        return this.$store.state.record.mainMediaTitle;
      },
      set(value) {
        this.$store.commit("updateMainMediaTitle", value);
      }
    },
    mainMediaHasPicture: {
      get() {
        return this.$store.state.record.mainMediaHasPicture;
      },
      set(value) {
        this.$store.commit("updateMainMediaHasPicture", value);
      }
    },
    mainMediaIsPictureOffensive: {
      get() {
        return this.$store.state.record.mainMediaIsPictureOffensive;
      },
      set(value) {
        this.$store.commit("updateMainMediaIsPictureOffensive", value);
      }
    },
    mainMediaBlameVictim: {
      get() {
        return this.$store.state.record.mainMediaBlameVictim;
      },
      set(value) {
        this.$store.commit("updateMainMediaBlameVictim", value);
      }
    },
    mainMediaDetails: {
      get() {
        return this.$store.state.record.mainMediaDetails;
      },
      set(value) {
        this.$store.commit("updateMainMediaDetails", value);
      }
    },
    mainMediaSources: {
      get() {
        return this.$store.state.record.mainMediaSources;
      },
      set(value) {
        this.$store.commit("updateMainMediaSources", value);
      }
    },
    mainMediaLink: {
      get() {
        return this.$store.state.record.mainMediaLink;
      },
      set(value) {
        this.$store.commit("updateMainMediaLink", value);
      }
    },
    otherMedia: {
      get() {
        return this.$store.state.record.otherMedia;
      },
      set(value) {
        this.$store.commit("updateOtherMedia", value);
      }
    },
  },
  methods: {
    dateFormattedMomentjs (value) {
      return value ? moment(value).format('DD/MM/YYYY') : '';
    },
    saveOtherMedia() {
      this.$store.commit("updateOtherMedia", this.otherMedia);
    },
    addOtherMedia() {
      this.otherMedia.push({});
    },
    deleteOtherMedia() {
      if (this.otherMedia.length == 1) {
        this.otherMedia = [
          {
            mainLink: undefined,
            followUpLink: undefined,
            selected: undefined
          }
        ];
      }
      else {
        const result = this.otherMedia.filter(media => media.selected !== true);
        this.otherMedia = result;
      }
    },
    visible(item) {
      switch (item) {
        case 'mainMediaLink':
          this.mainMediaLinkVisible = !this.mainMediaLinkVisible;
          break;
      }
    }
  },
  mounted() {
  }
};
</script>
<style scoped lang="scss">
#news {
  .add {
    font-size: 13px;
  }
  .victim-btn {
    font-weight: 600;
    text-transform: none;
    color: #840515;
  }
}
</style>
